import { ChevronRight } from "lucide-react";

const getScenarioClass = (idx, currentScenarioIndex) => {
  if (idx < currentScenarioIndex) return "bg-green-100 text-green-700";
  if (idx === currentScenarioIndex) return "font-semibold";
  return "bg-gray-100 text-gray-400";
};

const getStageClass = (stage, currentStage) => {
  if (stage < currentStage) return "bg-green-500 text-white";
  if (stage === currentStage) return "text-white";
  return "bg-gray-200 text-gray-500";
};

export const AssessmentBreadcrumb = ({ scenarios, currentScenarioIndex, currentStage, totalScenarios }) => (
  <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 shadow-lg">
    <div className="flex items-center gap-2 text-sm flex-wrap">
      {scenarios.map((scenario, idx) => (
        <div key={scenario.id} className="flex items-center gap-2">
          <div
            className={`flex items-center gap-1 px-3 py-1 rounded-lg ${getScenarioClass(idx, currentScenarioIndex)}`}
            style={idx === currentScenarioIndex ? { backgroundColor: '#FFD04A', color: '#231F20' } : {}}
          >
            {idx < currentScenarioIndex && <span className="text-xs">✓</span>}
            <span>{scenario.title}</span>
          </div>
          {idx < totalScenarios - 1 && <ChevronRight className="w-4 h-4 text-gray-400" />}
        </div>
      ))}
    </div>

    <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-200">
      <span className="text-xs text-gray-600 font-medium">Stages:</span>
      {[1, 2, 3].map((stage) => (
        <div
          key={stage}
          className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold ${getStageClass(stage, currentStage)}`}
          style={stage === currentStage ? { backgroundColor: '#FF751F' } : {}}
        >
          {stage < currentStage ? "✓" : stage}
        </div>
      ))}
    </div>
  </div>
);
